import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "../pages/HomePage";
import PrintOut from "../pages/PrintOut";
import RegistrationPage from "../pages/RegistrationPage";
import AttendancePage from "../pages/AttendancePage";
import ManageRegistration from "../pages/ManageRegistration";
import MyNavbar from "../components/MyNavbar";
import { loggedInUser, projectAccount } from "../httpService";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/Login";
import AttendanceMonitor from "../pages/AttendanceMonitor";
import PrintTags, { SpecialTags } from "../pages/PrintTags";
import SinglePageRegistration from "../pages/SinglePageRegistration";
import UpdateRegistration from "../pages/UpdateRegistration";
import DeleteRegistrations from "../pages/DeleteRegistrations";
import JambRegistrationPage from "../pages/JambRegistrationPage";
import JambStaffPrintout from "../pages/JambStaffPrintout";
import SpecialRegistrationPage from "../pages/SpecialRegistration";
import GuestPrintout from "../pages/GuestPrintout";
import JambTagsPrintout from "../pages/JambTagsPrintout";
import SpecialTagsPrintout from "../pages/SpecialTagsPrintout";

const publicRoutes = [
  { path: "/", component: HomePage },
  { path: "/printout/:id", component: PrintOut },
  { path: "/jambstaffprintout/:id", component: JambStaffPrintout },
  { path: "/registrations", component: RegistrationPage },
  { path: "/stafflogin", component: LoginPage },
  { path: "/printtags", component: PrintTags },
  { path: "/dashboard", component: RegistrationPage },
  { path: "/updateregistration/:id", component: SinglePageRegistration },
  { path: "/updateregistration", component: UpdateRegistration },
  { path: "/jambregistration", component: JambRegistrationPage },
  { path: "/specialtags", component: SpecialTags },
  { path: "/specialregistration", component: SpecialRegistrationPage },
  { path: "/guestprintout/:id", component: GuestPrintout },

  { path: "*", component: NotFound },
];

const privateRoutes = [
  { path: "/", component: RegistrationPage },
  { path: "/attendance/:id", component: AttendancePage },
  { path: "/manageregistrations", component: ManageRegistration },
  { path: "/attendancemonitor", component: AttendanceMonitor },
  { path: "/printtags", component: PrintTags },
  { path: "/specialtags", component: SpecialTags },
  { path: "/deleteregistrations", component: DeleteRegistrations },
  { path: "/jambregistration", component: JambRegistrationPage },
  { path: "/jambstaffprintout/:id", component: JambStaffPrintout },
  { path: "/jambtagsprintout", component: JambTagsPrintout },
  { path: "/specialtagsprintout", component: SpecialTagsPrintout },
  //special registration
  { path: "/specialregistration", component: SpecialRegistrationPage },

  { path: "*", component: NotFound },
];

export const navigationLinks = loggedInUser
  ? [
      { name: "Home", path: "/" },
      { name: "Manage Registrations", path: "/manageregistrations" },
      { name: "Attendance Monitor", path: "/attendancemonitor" },
      { name: "Print Tags", path: "/printtags" },
      { name: "Special Tags", path: "/specialtags" },
    ]
  : [{ path: "/", name: "Home" }];

export const msAutoLinks = loggedInUser
  ? [
      {
        name: "Logout",
        type: "button",
        action: () => {
          localStorage.removeItem(projectAccount);
          window.location.assign("/");
        },
      },
    ]
  : [{ name: "Staff Login", path: "/stafflogin" }];
function MainRoutes() {
  return (
    <BrowserRouter>
      <MyNavbar />
      <Routes>
        {loggedInUser ? (
          <>
            {privateRoutes.map((c, i) => (
              <Route key={i} path={c.path} element={<c.component />} />
            ))}
          </>
        ) : (
          <>
            {publicRoutes.map((c, i) => (
              <Route key={i} path={c.path} element={<c.component />} />
            ))}
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default MainRoutes;
